import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import { Observable } from 'rxjs';
import { resultadoEncuesta } from './models/resultadoEncuesta';


@Injectable({
  providedIn: 'root'
})
export class ReporteBaremoService {

  constructor(private http: HttpClient) { }

  private async request(method: string, url: string, data?: any, params?: any) {
    //const token = await this.oktaAuth.getAccessToken();

    const result = this.http.request(method, url, {
      body: data,
      params: params,
      responseType: "json",
      observe: "body",
      headers: {
        //  Authorization: `Bearer ${token}`
      },
    });
    return new Promise((resolve, reject) => {
      result.subscribe(resolve, reject);
    });
  }
  getInterpretacion(id,perfil) {
    console.log(`${environment.serverUrl}`);
    return this.request(
      "GET",
      `${environment.serverUrl}/obtenerInterpretacion`,
      {},
      { "id":id,
        "perfil":perfil
      }
    );
  }

  getReportBase64(parametrosPDF){
    return this.request(
      "POST",
      `${environment.serverUrl}/reportePDF`,
      parametrosPDF
    );
  }

  getInformacionPDF(id,perfil) {
    return this.request(
      "GET",
      `${environment.serverUrl}/generarPDF`,
      {},
      { "id":id,
        "perfil":perfil
      }
    );
  }

  getInformacionPDFPorSeccion(id,seccion,usuario,rol,coordinador) {
    return this.request(
      "GET",
      `${environment.serverUrl}/generarPDFPorSeccion`,
      {},
      { "encuesta":id,
        "seccion":seccion,
        "usuario":usuario,
        "rol":rol,
        "coordinador":coordinador
      }
    );
  }


  getPlantilla(id) {
    return this.request(
      "GET",
      `${environment.serverUrl}/plantillaReporte`,
      {},
      { 
        "id":id
      }
    );
  }

  getPerfilPorRegistro(encuesta, registro) {
    return this.request(
      "GET",
      `${environment.serverUrl}/getPerfilPorRegistro`,
      {},
      { 
        "encuesta":encuesta,
        "registro":registro
      }
    );
  }

}
